const C = {
  bg:      '#F8FDF9',
  dark:    '#0F2D1E',
  primary: '#2D6A4F',
  accent:  '#52B788',
  amber:   '#F59E0B',
  white:   '#FFFFFF',
};

const ff = {
  head: 'Fredoka One, sans-serif',
  body: 'Nunito, sans-serif',
};

const PAGE_CSS = `
  .tu-footer-link { color: rgba(255,255,255,0.6); text-decoration: none; font-family: 'Nunito', sans-serif; font-size: 13px; font-weight: 700; transition: color 0.15s; }
  .tu-footer-link:hover { color: #52B788; }
  .tu-back-link { color: #2D6A4F; text-decoration: none; font-family: 'Nunito', sans-serif; font-size: 14px; font-weight: 700; transition: opacity 0.15s; }
  .tu-back-link:hover { opacity: 0.7; }
  .tu-section h2 { font-family: 'Nunito', sans-serif; font-size: 17px; font-weight: 800; color: #0F2D1E; margin: 32px 0 10px; }
  .tu-section p, .tu-section li { font-family: 'Nunito', sans-serif; font-size: 15px; color: #3D5A4A; line-height: 1.75; margin: 0 0 10px; }
  .tu-section ul { padding-left: 22px; margin: 0 0 10px; }
  .tu-section a { color: #2D6A4F; }
`;

const EFFECTIVE_DATE = 'January 1, 2026';

export default function TermsOfUse() {
  return (
    <>
      <style>{PAGE_CSS}</style>
      <div style={{ background: C.bg, minHeight: '100vh', fontFamily: ff.body }}>

        {/* ── NAV ── */}
        <nav style={{
          background: C.white,
          borderBottom: '1px solid #e8f4ed',
          padding: '0 24px',
        }}>
          <div style={{
            maxWidth: 1100, margin: '0 auto', height: 64,
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <a href="/" style={{ textDecoration: 'none' }}>
              <span style={{ fontFamily: ff.head, fontSize: 22, color: C.dark, letterSpacing: 0.5 }}>
                🌱 ThriveTrack
              </span>
            </a>
            <a href="/" className="tu-back-link">← Back to Home</a>
          </div>
        </nav>

        {/* ── CONTENT ── */}
        <main style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px 80px' }}>
          <div style={{
            background: C.white,
            borderRadius: 20,
            border: '1px solid #D8F3DC',
            padding: '40px 44px',
          }}>
            <h1 style={{
              fontFamily: ff.head,
              fontSize: 32,
              color: C.dark,
              marginBottom: 6,
              letterSpacing: 0.5,
            }}>
              Terms of Use
            </h1>
            <p style={{ fontFamily: ff.body, fontSize: 13, color: '#8AA89A', marginBottom: 0 }}>
              Effective Date: {EFFECTIVE_DATE}
            </p>

            <div style={{
              height: 3, width: 48, background: C.amber,
              borderRadius: 2, margin: '20px 0 32px',
            }} />

            <div className="tu-section">

              <h2>1. Acceptance of Terms</h2>
              <p>
                By downloading, installing, accessing, or using ThriveTrack (the "App"), you agree to
                be bound by these Terms of Use ("Terms"). If you do not agree to these Terms, do not
                use the App.
              </p>

              <h2>2. Description of Service</h2>
              <p>
                ThriveTrack is a family task and reward tracking application that allows parents to
                create missions, assign rewards, and track their children's progress toward family
                goals. The App is offered in two tiers:
              </p>
              <ul>
                <li><strong>Free Plan</strong> — core features available at no charge, limited to two children.</li>
                <li><strong>Pro Plan</strong> — full feature access via a paid subscription (see Section 4).</li>
              </ul>
              <p>
                We reserve the right to modify, suspend, or discontinue any feature of the App at any
                time without notice.
              </p>

              <h2>3. User Accounts</h2>
              <p>
                To use ThriveTrack you must create a parent account. By creating an account you
                represent that:
              </p>
              <ul>
                <li>You are at least 18 years of age.</li>
                <li>All registration information you provide is accurate and current.</li>
                <li>You will keep your password confidential and notify us immediately of any unauthorized use.</li>
              </ul>
              <p>
                You are solely responsible for all activity that occurs under your account. Thrive Track
                LLC is not liable for any loss resulting from unauthorized use of your account.
              </p>

              <h2>4. Subscription Billing</h2>
              <p>ThriveTrack Pro is available at the following prices:</p>
              <ul>
                <li><strong>Monthly Plan:</strong> $9.99 per month, billed monthly.</li>
                <li><strong>Annual Plan:</strong> $79.99 per year, billed as a single annual charge.</li>
              </ul>
              <p>
                Subscriptions automatically renew unless cancelled at least 24 hours before the end of
                the current billing period. Payment is charged to your Apple ID account at confirmation
                of purchase. You can manage or cancel your subscription at any time in your Apple ID
                account settings. We do not provide refunds for partial subscription periods or unused
                portions of a term.
              </p>

              <h2>5. No Guarantee of Service</h2>
              <p>
                THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS
                OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                PARTICULAR PURPOSE, OR NON-INFRINGEMENT. We do not warrant that the App will be
                uninterrupted, error-free, secure, or free of viruses or other harmful components.
              </p>

              <h2>6. Limitation of Liability</h2>
              <p>
                TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THRIVE TRACK LLC AND ITS OFFICERS,
                DIRECTORS, EMPLOYEES, AND AGENTS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
                SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF
                THE APP, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT
                SHALL OUR TOTAL CUMULATIVE LIABILITY EXCEED THE GREATER OF (A) THE AMOUNTS YOU PAID TO
                US IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM, OR (B) ONE HUNDRED DOLLARS ($100).
              </p>

              <h2>7. Governing Law</h2>
              <p>
                These Terms are governed by and construed in accordance with the laws of the State of
                California, without regard to its conflict of law provisions. You agree to submit to
                the exclusive jurisdiction of the state and federal courts located in California for
                resolution of any dispute arising under these Terms.
              </p>

              <h2>8. Changes to These Terms</h2>
              <p>
                We may update these Terms from time to time. When we do, we will revise the effective
                date above. Your continued use of the App after any changes constitutes your acceptance
                of the revised Terms. We encourage you to review these Terms periodically.
              </p>

              <h2>9. Contact Us</h2>
              <p>
                If you have any questions about these Terms, please contact us at:{' '}
                <a href="mailto:hello@thethrivetrack.com">hello@thethrivetrack.com</a>
              </p>

            </div>
          </div>
        </main>

        {/* ── FOOTER ── */}
        <footer style={{
          background: C.dark,
          borderTop: '1px solid rgba(82,183,136,0.12)',
          padding: '36px 24px 28px',
        }}>
          <div style={{
            maxWidth: 1100, margin: '0 auto',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            flexWrap: 'wrap', gap: 20,
          }}>
            <div>
              <div style={{ fontFamily: ff.head, fontSize: 20, color: C.white, marginBottom: 6 }}>
                🌱 ThriveTrack
              </div>
              <div style={{ fontFamily: ff.body, fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>
                Helping families grow together 🌱
              </div>
            </div>
            <div style={{ display: 'flex', gap: 28, alignItems: 'center', flexWrap: 'wrap' }}>
              <a href="/privacy" className="tu-footer-link">Privacy Policy</a>
              <a href="/terms" className="tu-footer-link" style={{ color: 'rgba(255,255,255,0.9)' }}>Terms of Use</a>
              <a href="mailto:hello@thethrivetrack.com" className="tu-footer-link">Support</a>
            </div>
          </div>
          <div style={{
            maxWidth: 1100, margin: '20px auto 0',
            borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: 18,
            textAlign: 'center',
          }}>
            <div style={{ fontFamily: ff.body, fontSize: 12, color: 'rgba(255,255,255,0.28)' }}>
              © 2026 Thrive Track LLC. All rights reserved.
            </div>
          </div>
        </footer>

      </div>
    </>
  );
}
